import { QRCodeSVG } from "qrcode.react";
import { MapPin, Banknote, CarTaxiFront } from "lucide-react";

export const bookingLink = (place) => `${window.location.origin}/ride?src=poster${place ? `&place=${encodeURIComponent(place)}` : ""}`;

const STEPS = [
  { icon: MapPin, t: "Scan & pin your pickup" },
  { icon: Banknote, t: "See your fare in Kina" },
  { icon: CarTaxiFront, t: "A blue taxi comes to you" },
];

export const Poster = ({ place }) => (
  <div className="poster-wrap mx-auto w-full max-w-[794px]" style={{ containerType: "inline-size" }}>
    <div data-testid="qr-poster" className="poster-sheet flex aspect-[210/297] w-full flex-col overflow-hidden bg-[#0B192C] text-white">
      <div className="flex items-center gap-[3cqw] px-[7cqw] pt-[7cqw]">
        <img src="/img/logo-taxi.png" alt="Comfort Taxi" className="h-[13cqw] w-[13cqw] object-contain" />
        <div>
          <p className="font-display text-[7cqw] font-extrabold leading-none">Comfort <span className="text-amber-400">Taxi</span></p>
          <p className="mt-[1cqw] text-[2.2cqw] font-semibold uppercase tracking-[0.25em] text-blue-200">Port Moresby</p>
        </div>
      </div>
      <h1 className="px-[7cqw] pt-[6cqw] font-display text-[9.5cqw] font-extrabold leading-[1.05]">
        Need a taxi?<br /><span className="text-amber-400">Scan to book.</span>
      </h1>
      <div className="mx-auto mt-[5cqw] rounded-[3cqw] bg-white p-[3cqw]">
        <QRCodeSVG data-testid="poster-qr-code" value={bookingLink(place)} size={512} level="H" fgColor="#0B192C" imageSettings={{ src: "/img/logo-taxi.png", height: 100, width: 100, excavate: true }} style={{ width: "46cqw", height: "46cqw" }} />
      </div>
      <p data-testid="poster-place" className="mt-[3cqw] min-h-[4cqw] text-center text-[3.6cqw] font-bold text-amber-400">{place}</p>
      <div className="mt-auto grid grid-cols-3 gap-[2.5cqw] px-[7cqw] pb-[5cqw]">
        {STEPS.map((s, i) => (
          <div key={s.t} className="rounded-[2cqw] bg-white/5 p-[2.5cqw] text-center ring-1 ring-white/10">
            <s.icon className="mx-auto h-[4.5cqw] w-[4.5cqw] text-amber-400" />
            <p className="mt-[1.5cqw] text-[2.3cqw] font-semibold leading-snug">{i + 1}. {s.t}</p>
          </div>
        ))}
      </div>
      <p className="bg-blue-700 py-[2.5cqw] text-center text-[2.3cqw] font-semibold">Upfront fares · Pay your driver in cash · {window.location.host}</p>
    </div>
  </div>
);
